import {Component, OnInit} from '@angular/core';
import {NewsSharedService} from '../../services/news-shared.service';
import {TranslateService} from '@ngx-translate/core';
import {LangChange} from '../../../../lang-change';
import {Language} from '../../../../common/models/language';
import {ActivatedRoute, Router} from '@angular/router';
import {PageDTO} from '../../../../common/dtos/PageDTO';
import {Events} from '../../../admin/components/events/events';
import {PagesServiceShared} from '../../services/pages-shared.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Utils} from '../../../../common/services/Utils';

@Component({
  selector: 'app-search-pages-news',
  templateUrl: './search-pages-news.component.html',
  styleUrls: ['./search-pages-news.component.scss']
})
export class SearchPagesNewsComponent extends LangChange implements OnInit {
  searchText: string;
  searchTextNew: string;
  page: PageDTO = new PageDTO();
  events: Events[];
  totalElements = 0;
  pagesTotalElements = 0;
  newsList: any[] = [];
  pagesList: any[] = [];
  count: number = 0;
  pageSize: number = 1;
  totalElementsForPagination = 0;

  constructor(public _translateService: TranslateService,
              private _router: Router,
              private route: ActivatedRoute,
              private _utils: Utils,
              private sanitizer: DomSanitizer,
              private newsSharedService: NewsSharedService,
              private pagesSharedService: PagesServiceShared) {
    super(_translateService);
  }

  onLangChange(language: Language): void {
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.searchTextNew = params['text'];
      this.loadData(true);
    });
  }

  loadData(resetPage) {
    this._utils.blockStart('');
    if (this.searchTextNew) {
      this.searchText = this.searchTextNew;
      this.page.filter = {search: this.searchText};
      this.page.size = this.pageSize;
      this.loadPagesData(resetPage).then(value => {
        this.loadNewsData(resetPage).then(value1 => {
          this.totalElements += this.pagesTotalElements;
          this.totalElementsForPagination = ((this.totalElements - this.page.size) === 0 ? this.totalElements : (this.totalElements - this.page.size));
          this._utils.blockStop();
        }, reason => {
          this._utils.notifyError('', '');
          console.log('loadNewsData error', reason);
        });
      }, reason => {
        this._utils.notifyError('', '');
        console.log('loadPagesData error', reason);
      });
    }
  }

  loadNewsData(resetPage) {
    return new Promise((resolve, reject) => {
      if (resetPage) this.page.pageNumber = 0;
      this.newsSharedService.searchText(this.page).subscribe(data => {
        if (data) {
          // console.log('newsSharedService', data);
          this.newsList = data['dtoList'];
          this.totalElements = data['totalElements'];
          resolve('done');
        }
      }, error => {
        reject(error);
      });
    });
  }

  loadPagesData(resetPage) {
    return new Promise((resolve, reject) => {
      if (resetPage) this.page.pageNumber = 0;
      this.pagesSharedService.searchText(this.page).subscribe(data => {
        if (data) {
          // console.log('pagesSharedService', data);
          this.pagesList = data['dtoList'];
          this.pagesTotalElements = data['totalElements'];
          resolve('done');
        }
      }, error => {
        reject(error);
      });
    });
  }

  sanitizeUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  sanitizeHtml(text: string) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  substringContent(text: string) {
    return text.substring(0, 600) + ((text.length > 600) ? '...' : '');
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/common-main/components/search-pages-news/search-pages-news.component.ts